import type { Socket } from "socket.io-client";

import { store } from "../../store";
import { eventListeners } from "./eventListeners";
import cq from "./CQ";

// TODO: makes this class initialize the socket connection and get rid of CQ
// Service can be used by React components that subscribe to its context
export class SocketService {
  private socket?: Socket;
  private _initialized: boolean;

  constructor() {
    this._initialized = false;
  }

  get initialized(): boolean {
    return this._initialized;
  }

  /**
   * @description Initializes connection to the server.
   */
  public async init(): Promise<SocketService> {
    const state: any = store.getState();
    const { provider } = state.auth;

    let accessToken: string | null = null;

    if (provider === "okta") {
      const { oktaClient } = await import("../okta");
      accessToken = await oktaClient.getAccessToken();
    } else if (provider === "nextologies") {
      // 🔹 fallback to Redux-stored session string
      accessToken = state.auth.token;
    }

    if (!provider || !accessToken) {
      console.warn(
        "SocketService: no provider/token available for socket connect"
      );
      return this;
    }

    const auth = { provider, token: accessToken };

    // 🔹 include provider + token in the CQ connect
    this.socket = cq.connectToSocket(auth);

    this.attachEventListeners();
    this._initialized = true;

    return this;
  }

  private attachEventListeners(): void {
    Object.entries(eventListeners).forEach(([event, listener]) =>
      this.socket?.on(event, listener)
    );
  }

  public emit(eventName: string, data: any): void {
    this.socket?.emit(eventName, data);
  }

  public selectShow(show: string): void {
    store.dispatch({ type: "SELECT_SHOW", show });
  }

  public getSocketId(): string | undefined {
    return this.socket?.id;
  }

  // disconnect - used when unmounting
  public disconnect(): void {
    Object.entries(eventListeners).forEach(([event, listener]) =>
      this.socket?.off(event, listener)
    );
    this.socket?.disconnect();
    this.socket = undefined;
  }
}

export default new SocketService();
